import(/* webpackMode: "eager" */ "/vercel/path0/src/app/catalog/submit/page.tsx");
